'use strict'

var DEFAULTS = {
	// Sliding animation duration (in milliseconds)
	slideDuration: 200,
	autoSlide: true,
	// Waiting time until next auto slide (in milliseconds)
	autoSlideWait: 3000,
	stopAutoSlideOnHover: true
}

var HeadSlider = function(el, config) {
	this.el = el;
	this.$el = $(el);
	this.$el.data('HeadSlider', this)

	$.extend(this, DEFAULTS, config)

	this.$slides = $('.head-slider__slide', el)
	this.$container = $('.head-slider__slides', el)
	this.$left = $('.head-slider__arrow-left', el)
	this.$right = $('.head-slider__arrow-right', el)
	this.$pills = $('.head-slider__pill', el)

	this.$activeSlide = this.$slides.filter('.active')
	this.$activePill = this.$pills.filter('.active')
	this.activeSlideIndex = this.$slides.index(this.$activeSlide)
}

var EVENT_NS = '.head-slider'
var EVENT_BEFORE_SLIDE = HeadSlider.EVENT_BEFORE_SLIDE = 'slide:before' + EVENT_NS
var EVENT_AFTER_SLIDE = HeadSlider.EVENT_AFTER_SLIDE = 'slide:after' + EVENT_NS

$.extend(HeadSlider.prototype, {
	init: function() {
		if (typeof Hammer != 'undefined') {
			this.hammer = new Hammer(this.el);
		}
		this.attachEventHandlers()
		if (this.autoSlide) {
			this.beginAutoSlide()
		}
		return this
	},
	attachEventHandlers: function() {
		if (this.hammer) {
			this.hammer.on('swipeleft', $.proxy(this.onSwipeLeft, this));
			this.hammer.on('swiperight', $.proxy(this.onSwipeRight, this));
		}
		this.$right.on('click', $.proxy(this.onRightBtnClick, this))
		this.$left.on('click', $.proxy(this.onLeftBtnClick, this))
		this.$pills.on('click', $.proxy(this.onPillClick, this))
		if (this.autoSlide && this.stopAutoSlideOnHover) {
			this.$el.on('mouseenter', $.proxy(this.onMouseEnter, this))
			this.$el.on('mouseleave', $.proxy(this.onMouseLeave, this))
		}
	},
	onSwipeLeft: function() {
		this.slide(1)
		this.resetAutoSlideTimer()
	},
	onSwipeRight: function() {
		this.slide(-1)
		this.resetAutoSlideTimer()
	},
	onRightBtnClick: function(e) {
		e.preventDefault()
		this.slide(1)
	},
	onLeftBtnClick: function(e) {
		e.preventDefault()
		this.slide(-1)
	},
	onPillClick: function(e) {
		e.preventDefault()
		var $pill = $(e.currentTarget)
		var index = this.$pills.index($pill)
		this.slideTo(index)
	},
	slide: function(offset) {
		if (offset === undefined) {
			offset = 1
		} else if (!offset) {
			return
		}
		if (offset < -this.$slides.length) {
			offset = -(-offset % this.$slides.length)
		}
		var nextIndex = this.activeSlideIndex + offset
		if (nextIndex < 0) {
			nextIndex = this.$slides.length + nextIndex
		} else if (nextIndex >= this.$slides.length) {
			nextIndex = nextIndex % this.$slides.length
		}

		this.slideTo(nextIndex)
	},
	slideTo: function(index) {
		var self = this
		this.$el.queue(function() {
			if (index == self.activeSlideIndex) {
				self.$el.dequeue()
				return
			}

			self.$el.trigger(EVENT_BEFORE_SLIDE, {index: index})

			self.$activePill.removeClass('active')
			self.$activePill = self.$pills.eq(index)
			self.$activePill.addClass('active')

			var $incomingSlide = self.$slides.eq(index)
			var $outgoingSlide = self.$activeSlide

			$incomingSlide.addClass('active incoming')
			$outgoingSlide.removeClass('active').addClass('outgoing')

			self.$activeSlide = $incomingSlide
			self.activeSlideIndex = index

			setTimeout(function() {
				$incomingSlide.removeClass('incoming')
				$outgoingSlide.removeClass('outgoing')

				self.$el
					.trigger(EVENT_AFTER_SLIDE)
					.dequeue()
			}, self.slideDuration)
		})
	},
	hasAutoSlideBegun: function() {
		return this.autoSlideIntervalId !== undefined
	},
	beginAutoSlide: function() {
		if (!this.hasAutoSlideBegun()) {
			var self = this
			this.autoSlideIntervalId = setInterval(function() {
				self.slide(1)
			}, this.autoSlideWait)
		}
	},
	resetAutoSlideTimer: function() {
		if (this.autoSlide) {
			this.stopAutoSlide()
			this.beginAutoSlide()
		}
	},
	stopAutoSlide: function() {
		if (this.hasAutoSlideBegun()) {
			clearInterval(this.autoSlideIntervalId)
			delete this.autoSlideIntervalId
		}
	},
	onMouseEnter: function() {
		if (this.autoSlide && this.stopAutoSlideOnHover) {
			this.stopAutoSlide()
		}
	},
	onMouseLeave: function() {
		if (this.autoSlide && this.stopAutoSlideOnHover) {
			this.beginAutoSlide()
		}
	}
})

module.exports = HeadSlider


/*****************
 ** WEBPACK FOOTER
 ** ./components/HeadSlider.js
 ** module id = 161
 ** module chunks = 0
 **/